<template>
  <v-menu v-if="showMenu"
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn v-on="{ ...on, ...onTooltip}"
                 :small="small"
                 icon
                 :class="iconClass">
            <v-icon :small="small"
                    color="primary">
              mdi-shield-check
            </v-icon>
          </v-btn>
        </template>
        <span>
          {{ tooltipFornecedorHomologado }}
        </span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense>
          <v-col cols="12" class="subtitle-1 font-weight-medium">
            {{ labelFornecedorHomologado }}
          </v-col>
        </v-row>
        <v-row v-for="fornecedor in fornecedoresHomologados"
               dense
               :key="fornecedor.id">
          <v-col cols="12">
            <px-span-tooltip v-if="fornecedor.codigoInterno"
                             top
                             text-class="caption"
                             :text="`(${fornecedor.codigoInterno})`"
                             tooltip="Código de referência"/>
            <span class="body-2">
              {{ fornecedor.fornecedor.pessoa.nome }}
            </span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>
<script>
import { isEmpty } from 'lodash';

export default {
  props: {
    produto: {
      type: Object,
      default: null,
    },
    iconClass: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuOpened: false,
    };
  },
  computed: {
    fornecedoresHomologados() {
      if (isEmpty(this.produto.fornecedoresProduto)) {
        return [];
      }
      return this.produto.fornecedoresProduto.filter(fp => fp.homologado);
    },
    tooltipFornecedorHomologado() {
      return this.fornecedoresHomologados && this.fornecedoresHomologados.length > 1 ? 'Produto com fornecedores homologados' : 'Produto com fornecedor homologado';
    },
    labelFornecedorHomologado() {
      return this.fornecedoresHomologados && this.fornecedoresHomologados.length > 1 ? 'Fornecedores homologados ao produto' : 'Fornecedor homologado ao produto';
    },
    showMenu() {
      return this.produto
        && this.fornecedoresHomologados
        && this.fornecedoresHomologados.length;
    },
  },
};
</script>
